import React from "react";
import PropTypes from "prop-types";
import { Box, Avatar, Typography } from "@mui/material";

const LogoPreview = ({ imageSrc }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 3,
      }}
    >
      <Avatar
        src={imageSrc}
        alt="Profile picture preview"
        sx={{
          width: 150,
          height: 150,
          border: "3px solid white",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        {!imageSrc && (
          <Typography variant="h5" color="text.secondary">
            ??
          </Typography>
        )}
      </Avatar>
    </Box>
  );
};

LogoPreview.propTypes = {
  imageSrc: PropTypes.string,
};

export default LogoPreview;
